import TableCell from '@mui/material/TableCell';
import { ITableHeadCell } from 'components/@shared/TableRemotePagination/types';
import { AppointmentResponseViewModel } from 'types/appointment';

import { AppointmentListCell } from './AppointmentListCell';

interface Props {
    columns: ITableHeadCell[];
    rowData: AppointmentResponseViewModel;
}

export const AppointmentListRow = ({ columns, rowData }: Props) => (
    <>
        {columns.map((item) => (
            <TableCell id={item.id} key={item.field}>
                <AppointmentListCell {...{ item, rowData }} />
            </TableCell>
        ))}
    </>
);
